'use client'

import { OverlayContent } from 'product-card/components/shared/OverlayContent'
import { ProductImage } from 'product-card/components/shared/ProductImage'
import { dataTestIds } from 'product-card/constants/dataTestIds'
import { useProductCard } from 'product-card/hooks/useProductCard/useProductCard'
import { useProductCardConsumerLayoutContext } from 'product-card/hooks/useProductCardConsumerLayoutContext'
import { useProductCardInteractionContext } from 'product-card/hooks/useProductCardInteractionContext/useProductCardInteractionContext'
import { useShowAsFeatured } from 'product-card/hooks/useShowAsFeatured/useShowAsFeatured'
import { ProductCardVariant } from 'product-card/types'

import { cx } from 'utils/cx'
import styles from './ProductImageContainer.module.scss'

export const ProductImageContainer = () => {
	const { handleMouseEnter, handleMouseLeave } =
		useProductCardInteractionContext()
	const { variant } = useProductCardConsumerLayoutContext()
	const { dataTestId } = useProductCard()

	const showAsFeatured = useShowAsFeatured()

	return (
		<fieldset
			className={cx(
				styles.productImageContainer,
				showAsFeatured && styles.featured
			)}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			data-testid={dataTestIds.productCardImageContainer(dataTestId)}
		>
			<ProductImage />
			{variant === ProductCardVariant.General && <OverlayContent />}
		</fieldset>
	)
}
